import { render, staticRenderFns } from "./login copy 3.vue?vue&type=template&id=77a1820d"
import script from "./login copy 3.vue?vue&type=script&lang=js"
export * from "./login copy 3.vue?vue&type=script&lang=js"
import style0 from "./login copy 3.vue?vue&type=style&index=0&id=77a1820d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports